import React from 'react'
import { AuthRoles } from "components/auth"

export const VouchersConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/vouchers`,
            component: React.lazy(() => import('./Vouchers'))
        }
    ]
}